/**
 * 開発者ログイン画面（/system-admin）
 *
 * MS(Cognito)を介さず、事前登録済みユーザーの社員番号+パスワードでログインする。
 * バックエンドの dev_login エンドポイント（DJANGO_ALLOW_DEV_LOGIN=True の環境でのみ有効）を利用する。
 * MS以外のログイン手段の存在を悟られないよう、画面は汎用的なログインフォームにしている。
 */
import { useState } from 'react';
import { devLogin } from '../../dashboard/api/dashboardApi.js';
import { setToken, setDevLogin } from '../../../auth/auth.js';
import { setMyPermissions } from '../../../auth/permissions.js';

const USER_EMAIL_KEY = 'mobibi_user_email';
const USER_NAME_KEY = 'mobibi_user_name';

export default function SystemAdminLoginPage({ onSuccess }) {
  const [employeeId, setEmployeeId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loggingIn, setLoggingIn] = useState(false);

  const handleLogin = async () => {
    if (!employeeId || !password) {
      setError('社員番号とパスワードを入力してください');
      return;
    }
    setLoggingIn(true);
    setError('');
    try {
      const result = await devLogin(employeeId, password);
      if (!result?.access_token) {
        throw new Error('ログインに失敗しました');
      }
      setToken(result.access_token, result.expires_in || 43200);
      setDevLogin();
      if (result.email) sessionStorage.setItem(USER_EMAIL_KEY, result.email);
      sessionStorage.setItem(USER_NAME_KEY, result.user_name || employeeId);
      setMyPermissions(result.data || []);
      onSuccess();
    } catch (err) {
      setError(err.message || '社員番号またはパスワードが正しくありません');
    } finally {
      setLoggingIn(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleLogin();
  };

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '100vh', background: '#f3f4f6',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    }}>
      <div style={{
        background: '#fff', borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        padding: '32px 40px', maxWidth: 400, width: '90%',
      }}>
        <h1 style={{ margin: '0 0 4px', fontSize: 20, fontWeight: 700, color: '#111827' }}>
          ログイン
        </h1>
        <p style={{ margin: '0 0 24px', fontSize: 13, color: '#6b7280' }}>
          社員番号とパスワードを入力してください。
        </p>

        <div style={{ marginBottom: 12 }}>
          <input
            type="text"
            placeholder="社員番号"
            value={employeeId}
            onChange={(e) => setEmployeeId(e.target.value)}
            onKeyDown={handleKeyDown}
            autoFocus
            style={{
              width: '100%', padding: '10px 14px', fontSize: 14,
              border: `1px solid ${error ? '#fca5a5' : '#d1d5db'}`,
              borderRadius: 8, outline: 'none', boxSizing: 'border-box',
            }}
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <input
            type="password"
            placeholder="パスワード"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyDown}
            style={{
              width: '100%', padding: '10px 14px', fontSize: 14,
              border: `1px solid ${error ? '#fca5a5' : '#d1d5db'}`,
              borderRadius: 8, outline: 'none', boxSizing: 'border-box',
            }}
          />
          {error && (
            <div style={{ marginTop: 8, fontSize: 12, color: '#dc2626' }}>{error}</div>
          )}
        </div>

        <button
          onClick={handleLogin}
          disabled={loggingIn}
          type="button"
          style={{
            width: '100%', padding: '10px', background: '#2563eb', border: 'none',
            borderRadius: 8, cursor: loggingIn ? 'not-allowed' : 'pointer',
            fontSize: 13, color: '#fff', fontWeight: 600,
            opacity: loggingIn ? 0.6 : 1,
          }}
        >
          {loggingIn ? 'ログイン中...' : 'ログイン'}
        </button>
      </div>
    </div>
  );
}
